import { render, staticRenderFns } from "./CategoryAdd.vue?vue&type=template&id=3cf5c97e&"
import script from "./CategoryAdd.vue?vue&type=script&lang=js&"
export * from "./CategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./CategoryAdd.vue?vue&type=style&index=0&media=screen&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports